import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import React, { Component } from "react";

//icons
import DateRange from "@material-ui/icons/DateRange";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FlightIcon from "@material-ui/icons/Flight";
import LocalOffer from "@material-ui/icons/LocalOffer";
import NotificIcon from "@material-ui/icons/NotificationImportant";
import Person from "@material-ui/icons/Person";
import Settings from "@material-ui/icons/Settings";
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";

import { AttachMoney, Build, Create, Group, People } from "@material-ui/icons";
import { connect } from "react-redux";
import { navigate } from "../actions/routerResolve";
import { setSystem } from "../actions/systemActions";
import { allowAccessComplete, allowAccessMenu, allowAccessToMissionRequestAdmin } from "../enums";

const styles = {
  root: {},
  nested: {},
};

class SideList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.auth.user.user.profile,
      isDev:false
    };
  }

  state = {
    open: false,
    selectedIndex: null,
  };

  componentDidMount() {
    let pathname = window.location.pathname;

    switch (pathname) {
      case "/schedule":
        this.setState({ selectedIndex: 1 });
        break;
      default:
        break;
    }
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleNavigate = (route) => {
    this.props.navigate(route);
    this.props.setSystem({ drawer: false });
  };

  handleListItemClick = (index) => {
    this.setState({ selectedIndex: index });
  };

  render() {
    return (
      <div style={styles.root}>
        <List component="nav">
          <ListItem
            button
            selected={this.state.selectedIndex === 0}
            onClick={() => {
              this.handleNavigate("/");
              this.handleListItemClick(0);
            }}
          >
            <ListItemIcon>
              <DateRange />
            </ListItemIcon>
            <ListItemText inset primary="Agenda" />
          </ListItem>

          {/* <ListItem button selected={this.state.selectedIndex === 1}  onClick={()=> {
                        this.handleNavigate('/schedule')
                        this.handleListItemClick( 1)
                        }}>
                        <ListItemIcon>
                            <DraftsIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Controle da frota" />
                    </ListItem> */}
          {/* <ListItem button selected={this.state.selectedIndex === 0} onClick={()=> {this.handleNavigate('/team')
                    this.handleListItemClick( 0)}}>
                        <ListItemIcon>
                            <DraftsIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Minha equipe" />
                    </ListItem> */}
          {allowAccessMenu.includes(this.state.role) ? (
            <div>
              <ListItem button onClick={this.handleClick}>
                <ListItemIcon>
                  <Settings />
                </ListItemIcon>
                <ListItemText inset primary="Configurações" />
                {this.state.open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                {allowAccessComplete.includes(this.state.role) && <ListItem
                    button
                    selected={this.state.selectedIndex === 2}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/users");
                      this.handleListItemClick(2);
                    }}
                  >
                    <ListItemIcon>
                      <Person />
                    </ListItemIcon>
                    <ListItemText inset primary="Usuários" />
                  </ListItem>}
                  <ListItem
                    button
                    selected={this.state.selectedIndex === 13}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/passengers");
                      this.handleListItemClick(13);
                    }}
                  >
                    <ListItemIcon>
                      <People />
                    </ListItemIcon>
                    <ListItemText inset primary="Passageiros" />
                  </ListItem>
                  {
                    this.state.isDev &&
                    <React.Fragment>
                      <ListItem button selected={this.state.selectedIndex === 3} style={styles.nested} onClick={() => {
                          this.handleNavigate('/cost-center')
                          this.handleListItemClick(3)
                      }}>
                          <ListItemIcon>
                              <AttachMoney />
                          </ListItemIcon>
                          <ListItemText inset primary="Autorizado por" />
                      </ListItem>
                      <ListItem button selected={this.state.selectedIndex === 4} style={styles.nested} onClick={() => {
                          this.handleNavigate('/sector-family')
                          this.handleListItemClick(4)
                      }} >
                          <ListItemIcon>
                              <Group />
                          </ListItemIcon>
                          <ListItemText inset primary="Função/Família" />
                      </ListItem>
                      <ListItem button selected={this.state.selectedIndex === 5} style={styles.nested} onClick={() => {
                          this.handleNavigate('/treatments')
                          this.handleListItemClick(5)
                      }}>
                          <ListItemIcon>
                              <Create />
                          </ListItemIcon>
                          <ListItemText inset primary="Tratamentos" />
                      </ListItem>
                    </React.Fragment>
                  }

{allowAccessComplete.includes(this.state.role) && <ListItem
                    button
                    selected={this.state.selectedIndex === 6}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/notification-groups");
                      this.handleListItemClick(6);
                    }}
                  >
                    <ListItemIcon>
                      <NotificIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Grupos de notificação" />
                  </ListItem>}
                  {
                    this.state.isDev&&
                    <React.Fragment>

                      <ListItem button selected={this.state.selectedIndex === 10} style={styles.nested} onClick={() => {
                          this.handleNavigate('/manufacturers')
                          this.handleListItemClick(10)
                      }}>
                          <ListItemIcon>
                              <Build />
                          </ListItemIcon>
                          <ListItemText inset primary="Fabricantes de aeronaves" />
                      </ListItem>
                      <ListItem button selected={this.state.selectedIndex === 9} style={styles.nested} onClick={() => {
                          this.handleNavigate('/aircrafts-types')
                          this.handleListItemClick(9)
                      }}>
                          {/* <ListItemIcon>
                              <TypeIcon />
                          </ListItemIcon> */}
                          <ListItemText inset primary="Tipos de aeronaves" />
                      </ListItem>
                      <ListItem button selected={this.state.selectedIndex === 8} style={styles.nested} onClick={() => {
                          this.handleNavigate('/aircrafts-models')
                          this.handleListItemClick(8)
                      }}>
                      {/* <ListItemIcon>
                          <TypeIcon />
                      </ListItemIcon> */}
                      <ListItemText inset primary="Modelos de aeronaves" />
                  </ListItem>
                    </React.Fragment>
                  }
                  {allowAccessComplete.includes(this.state.role) && <ListItem
                    button
                    selected={this.state.selectedIndex === 7}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/aircrafts");
                      this.handleListItemClick(7);
                    }}
                  >
                    <ListItemIcon>
                      <FlightIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Aeronaves" />
                  </ListItem>}
                  {allowAccessComplete.includes(this.state.role) &&<ListItem
                    button
                    selected={this.state.selectedIndex === 11}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/providers");
                      this.handleListItemClick(11);
                    }}
                  >
                    <ListItemIcon>
                      <StoreMallDirectory />
                    </ListItemIcon>
                    <ListItemText inset primary="Fornecedores" />
                  </ListItem>}
                  {allowAccessComplete.includes(this.state.role) &&<ListItem
                    button
                    selected={this.state.selectedIndex === 12}
                    style={styles.nested}
                    onClick={() => {
                      this.handleNavigate("/provider-type");
                      this.handleListItemClick(12);
                    }}
                  >
                    <ListItemIcon>
                      <LocalOffer />
                    </ListItemIcon>
                    <ListItemText inset primary="Tipos de Fornecedores" />
                  </ListItem>}
                </List>
              </Collapse>
            </div>
          ) : null}
        </List>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

const mapDispatchToProps = {
  navigate,
  setSystem,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideList);



// WEBPACK FOOTER //
// ./src/components/SideList.js